export default "__VITE_ASSET__DmR9i_Kt__"